let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("pY5WL")).then(() => parcelRequire('4svq5'));